import { apiRequest } from './core/client';
import type { MessageTracking, RecentOpen } from '@/types/email';

export type { MessageTracking, RecentOpen };

// ============================================================================
// Message Tracking
// ============================================================================

export async function getMessageTracking(messageId: string): Promise<MessageTracking> {
  const response = await apiRequest<unknown>({
    path: `/messages/${encodeURIComponent(messageId)}/tracking`,
    method: 'GET',
  });
  return response as MessageTracking;
}

export async function getTrackingBatch(
  messageIds: string[]
): Promise<Record<string, { totalOpens: number; realOpens: number; lastOpenedAt: string | null }>> {
  const response = await apiRequest<unknown>({
    path: `/track/batch`,
    method: 'POST',
    body: { messageIds },
  });
  const record = response as Record<string, unknown>;
  return (record.summaries as Record<
    string,
    { totalOpens: number; realOpens: number; lastOpenedAt: string | null }
  >) || {};
}

export async function getRecentOpens(accountId: string, limit = 50): Promise<RecentOpen[]> {
  const response = await apiRequest<unknown>({
    path: `/track/recent?accountId=${encodeURIComponent(accountId)}&limit=${limit}`,
    method: 'GET',
  });
  const record = response as Record<string, unknown>;
  const opensArray = Array.isArray(record.opens) ? record.opens : [];
  return opensArray as RecentOpen[];
}
